import api from './api';

/**
 * Fetch today's six sector scores.
 * Server lazy-generates scores if they don't exist yet for today.
 */
export const getTodayScores = async () => {
  const { data } = await api.get('/scores/today');
  return data;
};

/**
 * Fetch score history for the last N days (default 30, max 365).
 */
export const getScoreHistory = async (days = 30) => {
  const { data } = await api.get('/scores/history', { params: { days } });
  return data;
};

/**
 * Fetch the combined dashboard summary:
 * today's scores + comfort zone ranges + status (green/amber/red) per sector.
 */
export const getScoreSummary = async () => {
  const { data } = await api.get('/scores/summary');
  return data;
};
